// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2cVjg","range":"MonthRangeSwitch_range__ydhjb","disabled":"MonthRangeSwitch_disabled__3Lx88"};